import React, { forwardRef } from 'react';

import { TagItem, TagsWrapper } from './TagsStyle';

const Tags = ({ tags = [], forwardedRef }) => (
	<TagsWrapper as='ul' wrap='wrap' top_M='12' justify='flex-start' ref={forwardedRef}>
		{tags.length > 0 && tags.map((item, index) => (
			<TagItem key={index}>{item}</TagItem>
		))}
	</TagsWrapper>
);

export default forwardRef((props, ref) => <Tags {...props} forwardedRef={ref} />);
